import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ApexNonAxisChartSeries, ApexChart, ApexPlotOptions, ApexDataLabels, ApexResponsive, ApexStroke, ChartComponent } from 'ng-apexcharts';

@Component({
  selector: 'app-donut',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss']
})
export class DonutComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() label!: string[];
  @Input() data!: number[];
  @Input() chartTitle = {};
  @Input() legendData = {};
  @Input() colorsData!: string[];
  @Input() mainTitle = { show: false, label: '' };
  @Input() defaultColor = "";
  @Input() currentTab = "";
  @Input() width!: number;
  @Input() type = "default";

  seriesData: ApexNonAxisChartSeries = [];
  chartData: ApexChart = { type: "donut" };
  plotOptions!: ApexPlotOptions;
  dataLabels!: ApexDataLabels;
  responsiveData: ApexResponsive[] = [
    { breakpoint: 480, options: { chart: { width: 200 }, legend: { position: "bottom" } } }
  ];
  stroke: ApexStroke = {};
  @ViewChild('chart') chart!: ChartComponent;
  constructor(private cdr: ChangeDetectorRef, private elRef: ElementRef) { }

  ngOnInit(): void {
    this.initializeChart();
  }

  ngAfterViewInit(): void {
    this.makeCircleClickable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['colorsData'] || changes['width']) {
      this.initializeChart();
      this.makeCircleClickable();
    }
  }

  initializeChart(): void {
    this.seriesData = this.data;
    if (this.width) {
      this.chartData.width = this.width;
    } else {
      delete this.chartData.width;
    }

    this.plotOptions = {
      pie: {
        expandOnClick: true,
        donut: {
          size: this.type === 'default' ? '58%' : '70%',
          labels: {
            show: this.mainTitle.show,
            name: { show: true, offsetY: 20 },
            total: {
              show: this.mainTitle.show,
              label: this.mainTitle.label,
              fontSize: '16px',
              color: '#A3A3A3'
            },
            value: {
              show: true,
              fontWeight: 'bold',
              fontSize: '32px',
              offsetY: -20
            }
          }
        }
      }
    };

    this.dataLabels = {
      enabled: true,
      formatter: (_, { seriesIndex }) => this.seriesData[seriesIndex]
    };

    this.stroke = { width: 0 };

    if (this.chart) {
      this.chart.updateOptions({
        chart: this.chartData,
        plotOptions: this.plotOptions,
        series: this.seriesData,
        dataLabels: this.dataLabels,
        stroke: this.stroke,
        colors: this.colorsData,
        legend: this.legendData,
        labels: this.label,
        responsive: this.responsiveData
      });
    }
  }

  makeCircleClickable(): void {
    setTimeout(() => {
      const circle = this.elRef.nativeElement.querySelector('circle');
      if (circle) {
        circle.style.cursor = 'pointer';
        circle.addEventListener('click', () => {
          this.chart?.chart?.events?.selection;
        });
      }
    }, 0);
  }
}